// Dependencies
import { useState, useRef, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import _ from 'lodash'; 
import _cx from 'classnames'; 

// Components
import {OptionField } from './OptionSelect';

// Types
import { Types, Components } from '../../utils/types';

// Utils
import {  } from '../../utils/config' 
import {  } from '../../utils/helpers' 

export const TextField = ({ type, name, value, min, max, placeholder, suffix }: Components.TextField) => {
    
    /**
     * States & Hooks
     */
    const inputFieldRef = useRef<any>(null);
    const [{name: fieldName, value: fieldValue, onBlur, onChange}, meta, helpers] = useField({name, value, type});
    const { submitForm } = useFormikContext();
    const [width, setWidth] = useState<number>(0);    
    
    // const recalculateWidth = ({currentTarget}: any) => {
    //     const charWidth = 10.5;
    //     setWidth(currentTarget.value.length * charWidth);
    // }

    const getFieldAutoComplete = () => {
        return ['tel', 'email'].includes(type) ? 'on' : 'off';
    }

    const getFieldInputMode = () => {

        const inputModes: any = {
            number: 'decimal',
            tel: 'tel',
            email: 'email',
            timerange: 'normal'
        }; 

        return type in inputModes ? inputModes[type] : undefined;

    }

    const maybeBlurField = ({target}: Event) => {
        if ( ! _.isNull(inputFieldRef.current) && inputFieldRef.current !== target ) {            
            inputFieldRef.current.blur();
            document.removeEventListener('click', maybeBlurField);
        }
    }

    const handleFieldFocus = () => {

        if ( ! _.isNull( inputFieldRef.current ) ) {
            //document.addEventListener('click', maybeBlurField);
        }

    }

    const handleKeyPress = (e: any) => {
        
        if ( e.key === 'Enter' ) {

            if (['tel', 'email'].includes(type) ) {
                submitForm()
            } else {
                inputFieldRef.current?.blur();
                if ( inputFieldRef.current.parentElement.parentElement?.nextElementSibling ) {
                    if ( inputFieldRef.current.parentElement.parentElement?.nextElementSibling?.querySelector('input') ) {
                        inputFieldRef.current.parentElement.parentElement.nextElementSibling.querySelector('input').focus();
                    }
                    inputFieldRef.current.parentElement.parentElement.nextElementSibling.scrollIntoView({block: "start", behavior: "smooth", inline: "nearest"});
                }
            }
    
        }

    }
    
    const validateField = (e: any) => {

        if ( ! _.isEmpty(e.currentTarget.value) || type === 'tel' ) {

            switch ( type ) {
                
                case 'number':
    
                    if ( ! e.currentTarget.value.match(/^[0-9]*(|\.[0-9]*)$/) ) {
                        e.currentTarget.value = fieldValue || '';
                        break;
                    }
                    
                    if ( min && e.currentTarget.value < min) {
                        e.currentTarget.value = fieldValue || '';
                        break;
                    }
    
                    if ( max && e.currentTarget.value > max) {
                        e.currentTarget.value = fieldValue || '';
                        break;
                    }
    
                    break;
    
                case 'email':
    
                    if ( ! e.currentTarget.value.match(/^[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789\@\+\_\-\.]{0,}$/) ) {
                        e.currentTarget.value = fieldValue || '';
                        break;
                    }
                    
                    break;
                    
                case 'timerange':
    
                    if ( ! e.currentTarget.value.match(/^[1234567890\s\-\:]{0,}$/) ) {
                        e.currentTarget.value = fieldValue || '';
                        break;
                    }
                    
                    break;
                    
                case 'tel':
    
                    if  ( ! e.currentTarget.value.match(/^(\+4219)\d{0,8}$/) ) {
                        e.currentTarget.value = fieldValue || '+4219';
                        break;
                    }
                    
                    break;
    
            }

        }

        onChange(e);

    }

    useEffect(() => {
        helpers.setValue(type === 'tel' ? '+4219' : '');
    }, [type])

    return (<>
       <input 
            ref={inputFieldRef} 
            className={_cx('form-field', 'text', {'is-valid': meta.touched && _.isEmpty( meta.error ) })}
            style={{
                width
            }}
            inputMode={getFieldInputMode()}
            autoComplete={getFieldAutoComplete()}
            min={min}
            max={max}
            // onInput={recalculateWidth} 
            type={'text'}
            name={fieldName}
            value={fieldValue}
            placeholder={placeholder}
            onFocus={handleFieldFocus}
            onBlur={onBlur}
            onChange={validateField}
            onKeyPress={handleKeyPress}
        />
        {suffix &&
            <span className="form-field__suffix">{suffix}</span>
        }
    </>)
 
}

export const FormField = ({type, ...props}: Components.FormField) => {

    switch ( type ) {
 
        case 'checkbox':
        case 'radio':
            return <OptionField type={type} {...props} />;

        case 'number':
        case 'text':
        case 'email':
        case 'tel':
        case 'timerange':
            return <TextField type={type} {...props} />;
 
        default:
            return null;
    }

}
 
export default FormField;
 